import Aos from "aos";
import React, { useEffect, useState } from "react";
import Header from "./Header";
import Loader from "./Loader";



const Commodities = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <>
      <Header />
      <br />
      <br />

      {isLoading ? (
        <Loader />
      ) : (
        <>
          <section className="bg-gradient-to-r from-[#11324c] to-[#11323e] text-white py-16">
            {/* The commodities Intro with call to actions button */}
            <div className="container mx-auto text-center px-6">
              <h1
                className="text-3xl sm:text-4xl font-semibold mb-4"
                data-aos="fade-up"
              >
                Shaping Tomorrow, One Landmark at a Time
              </h1>
              <p
                className="text-lg sm:text-xl mb-8"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                At Arqelio, we bring vision to life — delivering smart,
                sustainable solutions across residential, commercial, and
                infrastructure projects.
              </p>

              <div className="flex justify-center space-x-4 mb-12">
                <a href="/services">
                  <button className="btn px-6 py-3 bg-blue-900 text-white font-semibold rounded-lg hover:bg-indigo-600 transition-transform">
                    Explore Our Services
                  </button>
                </a>
                <a href="/contactus">
                  <button className="btn px-6 py-3 border-2 border-white text-white font-semibold rounded-lg hover:bg-orange-400 hover:text-yellow-50 transition-transform">
                    Request a Custom Quote
                  </button>
                </a>
              </div>

              <img
                src="/logo.png"
                alt="Arqelio Logo"
                className="mx-auto w-1/2 sm:w-1/3 h-auto rounded-lg mb-12 transition-all duration-300 bg-gradient-to-r from-[#11324c] to-[#11323e]"
                data-aos="fade-up"
                data-aos-delay="400"
              />
            </div>
          </section>

          <section className="bg-gradient-to-r from-slate-700 to-gray-900 text-white py-12">
            <div className="container mx-auto text-center px-6">
              <p
                className="text-lg sm:text-xl text-white mt-12"
                data-aos="fade-up"
                data-aos-delay="1000"
              >
                With decades of experience, we deliver excellence in every
                project. Let’s build something amazing together.
              </p>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default Commodities;
